


































  import { Component, Vue,Watch } from "vue-property-decorator";
  import VueElementLoading from "vue-element-loading";
  import { RotateSquare2 } from "vue-loading-spinner";
  import { store, StoreState } from "../store";
  import { mapState } from "vuex";
  import { SIDEBAR_DATA } from "../lib/constant";
  import DashLogo from "./DashLogo.vue";
  import AES from 'crypto-js/aes';
  import CryptoJS from 'crypto-js';
  //D:\Facile Projects\Hellospoke\dashboard_morit_2.0\src\views\Logout.vue
  import logout from '../views/Logout.vue';
  import NotificationModal from '../views/NotifiactionModal.vue'
@Component({
  components: {
    RotateSquare2,
    VueElementLoading,
    DashLogo,logout,NotificationModal
  },
  computed: {   
    ...mapState({
      notifications: (state: StoreState) => state.dashboard.notifications,
      notification_load: (state: StoreState) =>state.dashboard.admin.notification_load,
      userfirstname: (state: StoreState) => state.dashboard.userfirstname,
      userlastname: (state: StoreState) => state.dashboard.userlastname,
      privilege_level:(state: StoreState) => state.account.privilege_level,
      'user_image_url': (state: StoreState) => state.dashboard.user_image_url,
      'session_timeout': (state: StoreState) => state.account.logout_status ,
      'ringtone': (state: StoreState) =>  state.dashboard.notifiaction_ringtone,
      'contacts': (state: StoreState) =>state.dashboard.contacts,
      'incoming_text': (state: StoreState) => state.dashboard.incoming_text,
       'readnotifactionfrom_badge': (state: StoreState) =>state.dashboard.readnotifactionfrom_badge

    })
  },
   mounted: function() {
      setTimeout(this.delay, 3000); 
    },
     methods: {
      handleFocusOut() {
      var self=this;
      setTimeout(function(){
        self.$data.notify=self.$data.model_status=false;
              }, 1000);
          }
    }
    
})
export default class Sidebar extends Vue {
  data() {
    return {
      model_status:false,
      logout_modal:false,
      Bell_ntfcnt:false,
      notify:false,
      header_delay:false
    };
  }


//https://element.eleme.io/#/en-US/component/notification
  @Watch('ringtone')
  notification_open() 
    {
      var textc=(this as any).incoming_text;
      var name= textc.contact.first_name +' '+ textc.contact.last_name;
      if((this as any).ringtone){
       this.$notify({
          title: name,
          message: textc.text,
          //duration:0,
          onClick:this.readalertnotification
        });
      }
    }

     readalertnotification()
    {
     var n=(this as any).$route.path!== "/TextingPanel";
      if(n){
        this.$router.push({ name: 'TextingPanel' });
        var self=this;
         setTimeout(function(){
                self.$store.commit('SET_NOTIFICATION_BADGE' ,true);
            }, 1000);
      }
      else{
        this.$store.commit('SET_NOTIFICATION_BADGE' ,true);
      }
    }
     

   delay(){
      this.$data.header_delay=true;
   }
   
  cancel_logout(){
    this.$data.logout_modal=false;
  }
  log_outclick(){
    this.$data.notify=this.$data.model_status=false;
      this.$data.logout_modal=true;
  }
  model_statusent(){
    this.$data.notify=false;
    this.$data.model_status=!this.$data.model_status;
  }
  Notificationmodal(){
    this.$data.model_status=false;
    this.$data.notify=true;
  }



   my_setting(){
       this.$router.push("/MySettings");
    }

    Notification(data){
      this.$data.active_imagebell=!this.$data.active_imagebell;
    }
    Contact(data){
      this.$data.active_imagecontact=!this.$data.active_imagecontact;
    }

 

   get notification_status(){
        console.log('notification_status');
        return (this as any).notifications.filter((e) => e.read == false).length
		}



}
